import { AjudaPopover, Dialog, DialogContent } from "@bookdental/ui";
import { Mail, LogOut, RotateCw } from "lucide-react";
import { toast } from "sonner";
import { trpc } from "@/lib/trpc";
import { useAuth } from "@/lib/auth";
import { AJUDA_ONBOARDING } from "@/lib/ajuda/dialogos/onboarding";

/**
 * Gate obrigatório: sem e-mail confirmado, ninguém acessa o app. TeamInvite casa o convite
 * pendente pelo e-mail digitado no cadastro, não por prova de posse da caixa — sem essa trava,
 * bastava saber o e-mail de alguém pra "entrar" na organização dela via um convite pendente pra
 * esse endereço, sem nunca ter recebido/lido o convite de verdade.
 *
 * Poll leve enquanto aberto: assim que o link é confirmado (em outra aba/dispositivo), esse
 * mesmo cache de `me.current` atualiza e o gate cai sozinho — sem precisar de F5.
 */
export function VerifyEmailModal() {
  const { user, signOut } = useAuth();
  trpc.me.current.useQuery(undefined, { refetchInterval: 4000 });

  const resend = trpc.me.resendVerification.useMutation({
    onSuccess: () => toast.success("E-mail de confirmação reenviado."),
    onError: (err) => toast.error(err.message || "Erro ao reenviar e-mail."),
  });

  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent
        hideClose
        className="flex w-full max-w-md flex-col items-center gap-0 overflow-hidden p-8 text-center sm:rounded-3xl"
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-100 text-brand-700">
          <Mail className="h-7 w-7" />
        </span>
        <div className="mt-4 flex items-center justify-center gap-1">
          <h1 className="text-xl font-bold text-zinc-900">Confirme seu e-mail</h1>
          <AjudaPopover>{AJUDA_ONBOARDING.confirmarEmail}</AjudaPopover>
        </div>
        <p className="mt-2 text-sm text-zinc-500">
          Mandamos um link de confirmação pra <strong>{user?.email}</strong>. Abra o e-mail e
          clique no link — essa tela libera sozinha assim que confirmar.
        </p>

        <button
          type="button"
          onClick={() => resend.mutate()}
          disabled={resend.isPending}
          className="mt-6 inline-flex h-11 w-full items-center justify-center gap-2 rounded-md bg-brand-600 text-sm font-semibold text-white shadow-md transition-colors hover:bg-brand-700 disabled:opacity-60"
        >
          <RotateCw className="h-4 w-4" />
          {resend.isPending ? "Reenviando..." : "Reenviar e-mail"}
        </button>
        <button
          type="button"
          onClick={signOut}
          className="mt-3 inline-flex items-center gap-1.5 text-sm text-zinc-500 transition-colors hover:text-zinc-700"
        >
          <LogOut className="h-4 w-4" />
          Errou o e-mail? Sair e cadastrar de novo
        </button>
      </DialogContent>
    </Dialog>
  );
}
